"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _disrupt = _interopRequireDefault(require("@ux/disrupt"));
const _excluded = ["children", "show"];
const UX_MESSAGE_OVERLAY_CLASSNAME = 'ux-message-overlay';

/**
 * <MessageOverlay/> component, props are inherited from <Disrupt/>
 *
 * @param {Object} props - Component props
 * @returns {Component} <MessageOverlay/>
 */
function MessageOverlay(_ref) {
  let {
      children,
      show
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (typeof show !== 'undefined' && !show) return null;
  return /*#__PURE__*/_react.default.createElement(_disrupt.default, rest, /*#__PURE__*/_react.default.createElement("div", {
    "data-version": "2400.2",
    className: `${UX_MESSAGE_OVERLAY_CLASSNAME}-content`
  }, children));
}
MessageOverlay.propTypes = {
  /** Children to render within */
  children: _propTypes.default.node,
  /** Defaults to false. If `true`, enables focus lock with default options.
  * If object, passes props directly to react-focus-lock */
  focusLock: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  /** Callback that fires when the user attempts to leave the component */
  onClose: _propTypes.default.func,
  /** Callback that fires when an event occurs behind the component */
  onEventBehind: _propTypes.default.func,
  /** Element to attach the component to, use `document.body` for "modal" behavior */
  portalElem: _propTypes.default.object,
  /** Method to attach the backdrop */
  strategy: _propTypes.default.oneOf(['absolute', 'fixed']),
  /** Stretches the width of the container */
  stretch: _propTypes.default.bool,
  /** Whether the component should be visible or not */
  show: _propTypes.default.bool
};
var _default = exports.default = MessageOverlay;